import Reveal from '@/components/base/Reveal';
import { sponsorBenefits, sponsorImage, sponsorPlans } from '@/mocks/site';

export default function Sponsor() {
  return (
    <section id="sponsor" className="bg-secondary-950 px-5 py-16 pr-14 md:px-10 md:py-24 md:pr-20">
      <div className="mx-auto max-w-6xl">
        <div className="grid items-end gap-8 md:grid-cols-12 md:gap-12">
          <div className="md:col-span-6">
            <Reveal variant="up">
              <div className="flex items-center gap-3">
                <span className="h-px w-8 bg-accent-400" />
                <p className="text-[10px] en-label text-accent-300">FOR COMPANIES</p>
              </div>
              <h2 className="mt-4 font-heading text-[26px] font-black leading-[1.35] text-background-50 md:text-[36px]">
                地域とつながる、
                <br />
                協賛のかたち。
              </h2>
              <p className="mt-5 max-w-lg text-[13px] leading-[2] text-background-50/70">
                このイベントは、地域の企業さまのご協賛によって成り立っています。商品やサービスのPRだけでなく、地域文化を支える取り組みとして、参加するすべての方に企業の想いが届きます。
              </p>
            </Reveal>
          </div>

          <Reveal variant="mask" duration={1200} className="md:col-span-6">
            <div className="h-[220px] w-full overflow-hidden rounded-md sm:h-[280px] md:h-[300px]">
              <img
                src={sponsorImage}
                alt="イベント会場で協賛企業の担当者と運営が打ち合わせをする様子"
                className="h-full w-full object-cover"
              />
            </div>
          </Reveal>
        </div>

        <div className="mt-12 grid gap-3 sm:grid-cols-2 md:mt-16 md:gap-4 lg:grid-cols-4">
          {sponsorBenefits.map((benefit, index) => (
            <Reveal
              key={benefit.title}
              variant="up"
              delay={index * 90}
              className="rounded-md border border-background-50/15 bg-background-50/[0.04] p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500/15 text-accent-300">
                <i className={`${benefit.icon} text-[17px]`} aria-hidden="true" />
              </span>
              <h3 className="mt-4 font-heading text-[14.5px] font-bold text-background-50">{benefit.title}</h3>
              <p className="mt-2 text-[11.5px] leading-[1.85] text-background-50/60">{benefit.text}</p>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 border-t border-background-50/12 pt-9 md:mt-16">
          <Reveal variant="up" className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="text-[10px] en-label text-background-50/45">SPONSORSHIP PLAN</p>
              <h3 className="mt-2 font-heading text-[19px] font-black text-background-50 md:text-[22px]">協賛プラン</h3>
            </div>
            <p className="text-[11.5px] leading-relaxed text-background-50/50">
              協賛金額は下記のとおりです。特典の詳細は個別にご案内します。
            </p>
          </Reveal>

          <div className="mt-6 grid gap-3 sm:grid-cols-2 md:gap-4 lg:grid-cols-4">
            {sponsorPlans.map((plan, index) => (
              <Reveal key={plan.name} variant="up" delay={index * 100}>
                <div className="flex h-full flex-col justify-between rounded-md border border-background-50/15 p-5 transition-colors duration-500 hover:border-accent-400/60 md:p-6">                  <div>
                    <p className="font-display text-[15px] tracking-[0.12em] text-accent-300">{plan.name}</p>
                    <p className="mt-2 font-heading text-[15px] font-bold text-background-50">{plan.label}</p>
                    <p className="mt-3 text-[10px] en-label text-background-50/40">PRICE</p>
                    <p className="mt-1 font-heading text-[17px] font-bold text-background-50">{plan.price}</p>
                    <p className="mt-3 text-[11.5px] leading-[1.85] text-background-50/55">{plan.note}</p>
                  </div>
                  <a
                    href="#contact"
                    className="mt-5 inline-flex cursor-pointer items-center gap-1.5 text-[11.5px] font-bold text-accent-300 transition-colors duration-300 hover:text-accent-200"
                  >
                    このプランで相談する
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </a>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal variant="fade" delay={120} className="mt-10 flex flex-col gap-4 rounded-md border border-background-50/15 bg-background-50/[0.04] p-5 sm:flex-row sm:items-center sm:justify-between md:px-7">
          <div>
            <p className="text-[10px] en-label text-background-50/45">SPONSOR LIST</p>
            <p className="mt-2 text-[12.5px] leading-relaxed text-background-50/75">
              協賛企業さまをご紹介します。<span className="text-background-50/45">（掲載企業は決定次第更新します）</span>
            </p>
          </div>
          <a
            href="#contact"
            className="inline-flex w-full cursor-pointer items-center justify-center gap-2 rounded-md bg-accent-500 px-5 py-3 text-[12.5px] font-bold text-foreground-950 transition-colors duration-300 hover:bg-accent-400 sm:w-auto"
          >
            <i className="ri-mail-send-line text-sm" aria-hidden="true" />
            協賛について相談する
          </a>
        </Reveal>
      </div>
    </section>
  );
}